export default "__VITE_ASSET__094a5dff__"